// extracted by mini-css-extract-plugin
export default {"account":"Auth_account__Dbysa","account_wrapper":"Auth_account_wrapper__Scggb","logo":"Auth_logo__arMPp","form":"Auth_form__784U9"};